var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPizzaSliceIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Pizza_Slice_icon_svg__clip0_4_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290 312.5l154.929 386.571c22.273 71.429-13.941 109.429-14.286 129.215-.357 20.5 20.952 40.714 42.488 31.202 12.643-5.583 19.476-19.333 17.286-32.976-1.429-8.953-1.786-20.786-.75-33 12.131 5.869 28.428 1.476 34.297-13.191l187.5-467.821c-130.857-73.262-290.607-73.262-421.464 0z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.464 312.5l23.905-24.405c19.381-19.786 21.905-50.643 5.857-73.226-2.928-4.119-5.654-7.298-7.857-8.714-141.809-90.762-323.452-90.762-465.262 0-1.274.821-2.833 2.238-4.583 4.083-21.786 23.131-20 59.774 3.452 81.214L290 312.488c130.857-73.262 290.607-73.262 421.464 0v.012z",
    fill: "#FD934F",
    stroke: "#BE7F4D",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.988 637.31c27.647 0 50.06-22.413 50.06-50.06 0-27.647-22.413-50.06-50.06-50.06-27.647 0-50.059 22.413-50.059 50.06 0 27.647 22.412 50.06 50.059 50.06zM573.357 487.297c27.647 0 50.06-22.412 50.06-50.059s-22.413-50.06-50.06-50.06c-27.647 0-50.059 22.413-50.059 50.06 0 27.647 22.412 50.059 50.059 50.059zM412.953 417.036c27.647 0 50.059-22.413 50.059-50.06 0-27.647-22.412-50.059-50.059-50.059s-50.06 22.412-50.06 50.059 22.413 50.06 50.06 50.06z",
    fill: "#FA505E",
    stroke: "#F93444",
    strokeWidth: 16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.548 567.226c0-16.107 13.059-29.166 29.167-29.166z",
    fill: "#FCC65B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.548 567.226c0-16.107 13.059-29.166 29.167-29.166",
    stroke: "#FFE888",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.083 306.893c22.12 0 40.048 17.928 40.048 40.047z",
    fill: "#FCC65B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.083 306.893c22.12 0 40.048 17.928 40.048 40.047",
    stroke: "#FFE888",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.798 479.786c-16.262-3.274-26.798-19.108-23.524-35.369z",
    fill: "#FCC65B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.798 479.786c-16.262-3.274-26.798-19.108-23.524-35.369",
    stroke: "#FFE888",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.405 817.476s-3.917-52.869 18.309-72.381",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.488 231.119c46.203-27.464 203.441-96.024 376.25 1.107",
    stroke: "#F9B485",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.226 346.941c5.53 0 10.012-4.483 10.012-10.012 0-5.53-4.482-10.012-10.012-10.012-5.529 0-10.012 4.482-10.012 10.012 0 5.529 4.483 10.012 10.012 10.012zM420.619 499.809c5.53 0 10.012-4.482 10.012-10.011 0-5.53-4.482-10.012-10.012-10.012-5.529 0-10.012 4.482-10.012 10.012 0 5.529 4.483 10.011 10.012 10.011zM513.083 687.381c5.53 0 10.012-4.482 10.012-10.012 0-5.529-4.482-10.012-10.012-10.012-5.529 0-10.012 4.483-10.012 10.012 0 5.53 4.483 10.012 10.012 10.012z",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Pizza_Slice_icon_svg__clip0_4_9"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizzaSliceIcon);
export default ForwardRef;